import React from 'react';
import Uganda_p6math from './uganda_p6math';
import Uganda_p6_subjects from './uganda_p6_subjects';
import Speech from "react-text-to-speech";

const Uganda_p6math_form_subsets = () => {
  return (
    <div>
      <Uganda_p6math />
      <Uganda_p6_subjects />
<div class=" right-0 left-0 top-38 min-h-screen scrollbar-hide relative inset-0 items-center justify-center bg-cyan-50 bg-opacity-30">
  <section className='flex'>
     <Speech text="Form subsets!" stableText={true} /> 
     <p>Form subsets</p>  
     </section>
     </div>


    </div>
  );
}

export default Uganda_p6math_form_subsets;
